/* eslint-disable arrow-body-style */
/* eslint-disable semi */
export default ({ team, positions, manager, substitutes, formations }) => {
  return `
    <div class="section section__panel section__large myteam__section">
      <div class="tactics__section flex-column flex-lg-row row">
          <div class="col-12 col-lg-5 team__info mb-3">
              <div class="panel__heading d-flex text-left">
                  <span><small>Tactics</small></span>
              </div>

              <div class="panel__body panel__teaminfo">
                  <div class="panel__teaminfo-logo">
                      <div class="row justify-content-center">
                          <div class="col-10 position-relative formation f${team.formation_name}" style="max-width: 434px;">
                              <img class="img-fluid" src="/assets/images/saha@2x.png" alt="logo" />
                              ${positions.map(item => (`
                                <span class="player js-add-team-player" style="cursor: pointer;" data-position="${item.position}" data-number="${item.order_no}"><img src="${item.image}" style="border-radius: 50px;${item.image}" class="img-fluid" alt="" /> ${item.position} </span>
                              `)).join('')}
                          </div>
                      </div>
                  </div>
                  <div class="panel__teaminfo-tactics px-4">
                      <div class="panel__teaminfo-row mt-2 flex-column flex-lg-row">
                          <div class="col-12 col-md-6 team-captain">
                              <label for="captain" class="tactic-option">Captain</label>
                              <div class="styled-select">
                                  <select name="captain" id="captain" class="styled js-team-setting">
                                  ${positions.filter(item => item.nft_id).map(item => (`
                                    <option value="${item.nft_id}" ${team.captain_nft_id === item.nft_id ? 'selected' : ''} >${item.name}</option>
                                  `))}
                                  </select>
                              </div>
                          </div>
                           <div class="col-12 col-md-6 freekick-player">
                              <label for="freekick" class="tactic-option">Freekick Player</label>
                              <div class="styled-select">
                                  <select name="freekick" id="freekick" class="styled js-team-setting">
                                  ${positions.filter(item => item.nft_id).map(item => (`
                                    <option value="${item.nft_id}" ${team.freekick_nft_id === item.nft_id ? 'selected' : ''} >${item.name}</option>
                                  `))}
                                  </select>
                              </div>
                          </div>

                      </div>

                      <div class="panel__teaminfo-row mt-2 flex-column flex-lg-row">
                          <div class="col-12 col-md-6">
                              <label for="formation" class="tactic-option">Formation</label>
                              <div class="styled-select">
                                  <select name="formation" id="formation" class="styled js-team-setting">
                                  ${formations.map(item => (`
                                    <option value="${item.id}" ${team.formation_id === item.id ? 'selected' : ''} ${item.available ? '' : 'disabled'}>${item.name}</option>
                                  `))}
                                  </select>
                              </div>
                          </div>
                          <div class="col-12 col-md-6">
                              <label for="game_sense" class="tactic-option">Game Sense</label>
                              <div class="styled-select">
                                  <select name="game_sense" id="game_sense" class="styled js-team-setting">
                                      <option value="50" ${team.game_sense === '50' ? 'selected' : ''}>Normal</option>
                                      <option value="70" ${team.game_sense === '70' ? 'selected' : ''}>Attack</option>
                                      <option value="40" ${team.game_sense === '40' ? 'selected' : ''}>Defense</option>
                                  </select>
                              </div>
                          </div>
                      </div>
                      <div class="panel__teaminfo-row mt-2 flex-column flex-lg-row">
                          <div class="col-12 col-md-6">
                              <label for="long_passes" class="tactic-option">Long Pass</label>
                              <div class="styled-select">
                                  <select name="long_passes" id="long_passes" class="styled js-team-setting">
                                      <option value="0" ${team.long_passes === '0' ? 'selected' : ''}>No</option>
                                      <option value="1" ${team.long_passes === '1' ? 'selected' : ''}>Yes</option>
                                  </select>
                              </div>
                          </div>
                          <div class="col-12 col-md-6">
                              <label for="counter_attacks" class="tactic-option">Counter Attack</label>
                              <div class="styled-select">
                                  <select name="counter_attacks" id="counter_attacks" class="styled js-team-setting">
                                      <option value="0" ${team.counter_attacks === '0' ? 'selected' : ''}>No</option>
                                      <option value="1" ${team.counter_attacks === '1' ? 'selected' : ''}>Yes</option>
                                  </select>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="col-12 col-lg-7 team__list mb-3">
              <div class="panel__heading d-flex text-left">
                  <span><small>Positions</small></span>
              </div>

              <div class="panel__body panel__teaminfo" style="overflow: scroll;height: 100%;">
                  <div class="d-flex my-team__row my-team__row-head">
                    <div class="my-team__move d-flex align-items-center justify-content-center text-center">Select</div>
                    <div class="my-team__position d-flex align-items-center justify-content-center text-center">Position</div>
                    <div class="my-team__id d-flex align-items-center text-center  justify-content-center">ID</div>
                    <div class="my-team__name d-flex align-items-center">Player Name</div>
                    <div class="my-team__overall_head d-flex align-items-center">Overall</div>
                    <div class="my-team__rarity d-flex align-items-center">Rarity</div>
                    <div class="my-team__action d-flex align-items-center justify-content-center text-center">Actions</div>
                  </div>
                  <div id="js-swap-table" class="table2 text-white">
                      ${positions.map((item, index) => (`
                        <div class="d-flex my-team__row my-team__row-item ${Number(item.order_no) >= 0 && !item.nft_id ? 'filtered' : ''} ${Number(item.order_no) >= 0 ? '' : 'subs'}" data-order_no="${index + 1}" data-nft_id="${item.order_no ? (item.nft_id || '') : (item.id || '')}" data-position_id="${item.position_id}">
                            <div class="my-team__move d-flex align-items-center justify-content-center text-center">
                              <button type="button" class="my-team__handle d-flex align-items-center justify-content-center">
                                <img src="/assets/images/tab.svg" style="width: 20px" />
                              </button>
                            </div>
                            <div class="my-team__position d-flex align-items-center justify-content-center text-center"${item.original_position < 0 ? (` style='background:#F44336;'`) : (``)}>${item.position}</div>
                            <div class="my-team__id d-flex align-items-center justify-content-center text-center">
                              ${item.generation === 1 && item.nft_id < 3278 ? ' <img class="my-team__id d-flex align-items-center justify-content-center text-center" src="/html/cornerkick/assets/images/gallery/avax.png"/>' : item.generation === 1 ? '<img class="my-team__id d-flex align-items-center justify-content-center text-center" src="/html/cornerkick/assets/images/gallery/chz.png"/>' : ''}
                            ${item.generation === 1 && item.nft_id < 1 ? ' <img class="my-team__id d-flex align-items-center justify-content-center text-center" src="/html/cornerkick/assets/images/gallery/free.png"/>' : item.generation === 2 ? '<img class="my-team__id d-flex align-items-center justify-content-center text-center" src="/html/cornerkick/assets/images/gallery/free.png"/>' : ''}
                            </div>
                            <div class="my-team__name d-flex align-items-center">
                                <div class="my-team__player-bg">
                                  <img src="${item.image}" class="img-fluid" alt="" />
                                </div>
                                <span><a href="${item.seo || '#'}" target="_blank">${item.name ? `${item.name} (${item.positions})` : 'Empty'}  ${team.captain_nft_id === item.nft_id ? `<img src="/assets/images/captain.jpg" style="width: 30px" />` : ''} ${team.freekick_nft_id === item.nft_id ? `<img src="/assets/images/freekick.webp" style="width: 20px" />` : ''}</a></span>
                            </div>
                             <div class="my-team__overall_head d-flex align-items-center">
                                ${item.overall ? `<div class="my-team__overall">${item.overall}</div>` : ''}
                                ${item.bonus ? `<div class="my-team__overall my-team__bonus">+${item.bonus}</div>` : ''}
                            </div>
                            <div class="my-team__rarity d-flex align-items-center">
                              ${item.star_count >= 1 ? '<i class="icofont-star"></i>' : ''}
                              ${item.star_count >= 2 ? '<i class="icofont-star"></i>' : ''}
                              ${item.star_count >= 3 ? '<i class="icofont-star"></i>' : ''}
                              ${item.star_count >= 4 ? '<i class="icofont-star"></i>' : ''}
                            </div>
                            <div class="my-team__action  d-flex align-items-center justify-content-center text-center">
                              ${item.name ? (`
                                <button class="btn btn-linebutton ml5 js-remove-team-player" data-nft_id="${item.nft_id}" data-generation="${item.generation}">
                                  Remove
                                </button>
                              `) : (`
                                <button class="btn btn-linebutton ml5 js-add-team-player" data-position="${item.position}" data-generation="${item.generation}">
                                  Add
                                </button>
                              `)}
                            </div>
                        </div>
                      `)).join('')}

                      ${substitutes.map((item, index) => (`
                        <div class="d-flex my-team__row my-team__row-item ${Number(item.order_no) >= 0 && !item.nft_id ? 'filtered' : ''} ${Number(item.order_no) >= 0 ? '' : 'subs'}" data-order_no="${index+12}" data-nft_id="${item.order_no ? (item.nft_id || '') : (item.id || '')}" data-position_id="${item.position_id}">
                            <div class="my-team__move d-flex align-items-center justify-content-center text-center">
                              <button type="button" class="my-team__handle d-flex align-items-center justify-content-center">
                                <img src="/assets/images/tab.svg" style="width: 20px" />
                              </button>
                            </div>
                            <div class="my-team__position d-flex align-items-center justify-content-center text-center"${item.original_position < 0 ? (` style='background:#F44336;'`) : (``)}>${item.position}</div>
                            <div class="my-team__id d-flex align-items-center justify-content-center text-center">

                            ${item.generation === 1 && item.nft_id < 3278 ? ' <img class="my-team__id d-flex align-items-center justify-content-center text-center" src="/html/cornerkick/assets/images/gallery/avax.png"/>' : item.generation === 1 ? '<img class="my-team__id d-flex align-items-center justify-content-center text-center" src="/html/cornerkick/assets/images/gallery/chz.png"/>' : ''}
                            ${item.generation === 1 && item.nft_id < 1 ? ' <img class="my-team__id d-flex align-items-center justify-content-center text-center" src="/html/cornerkick/assets/images/gallery/free.png"/>' : item.generation === 2 ? '<img class="my-team__id d-flex align-items-center justify-content-center text-center" src="/html/cornerkick/assets/images/gallery/free.png"/>' : ''}</div>
                            <div class="my-team__name d-flex align-items-center">
                                <div class="my-team__player-bg">
                                  <img src="${item.image}" class="img-fluid" alt="" />
                                </div>
                                <span><a href="${item.seo || '#'}" target="_blank">${item.name ? `${item.name} (${item.positions})` : 'Empty'}</a></span>
                            </div>
                            <div class="my-team__overall_head d-flex align-items-center">
                                ${item.overall ? `<div class="my-team__overall">${item.overall}</div>` : ''}
                            </div>
                            <div class="my-team__rarity d-flex align-items-center">
                              ${item.star_count >= 1 ? '<i class="icofont-star"></i>' : ''}
                              ${item.star_count >= 2 ? '<i class="icofont-star"></i>' : ''}
                              ${item.star_count >= 3 ? '<i class="icofont-star"></i>' : ''}
                              ${item.star_count >= 4 ? '<i class="icofont-star"></i>' : ''}
                            </div>
                            <div class="my-team__action  d-flex align-items-center justify-content-center text-center">
                              ${item.name ? (`
                                <button class="btn btn-linebutton ml5 js-remove-team-player" data-nft_id="${item.nft_id}" data-generation="${item.generation}">
                                  Remove
                                </button>
                              `) : (`
                                <button class="btn btn-linebutton ml5 js-add-team-player" data-position="${item.position}" data-generation="${item.generation}">
                                  Add
                                </button>
                              `)}
                            </div>
                        </div>
                      `)).join('')}
                  </div>
              </div>
          </div>
      </div>
    </div>
  `
};
